import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import 'rc-tooltip/assets/bootstrap.css';
import '../system/style/theme/style.scss';
import '../system/style/icons/style.css';

export default true;